import { topics } from '../data';
import SectionHeader from './SectionHeader';

export default function Topics() {
  return (
    <section id="topic" className="mx-auto w-full max-w-7xl scroll-mt-20 px-4 py-16 md:px-6 md:py-20">
      <SectionHeader
        kicker="Topic Collections"
        title="精品吃瓜专题"
        desc="把同类话题系统整理成册的专题专区。按主题沉浸式阅读，从事件脉络到栏目盘点一次看全。"
      />
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {topics.map((t, i) => (
          <article
            id={`topic-card-${t.id}`}
            key={t.id}
            className={`group flex scroll-mt-24 flex-col overflow-hidden rounded-2xl border border-background-200/80 bg-background-50 transition hover:border-accent-300 ${
              i % 2 === 0 ? 'lg:col-span-2 lg:flex-row' : 'lg:col-span-2'
            }`}
          >
            <div className={`relative h-52 w-full shrink-0 overflow-hidden ${i % 2 === 0 ? 'lg:h-auto lg:w-1/2' : 'lg:w-1/2'}`}>
              <img
                src={t.image}
                alt={t.alt}
                className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
              />
              <span className="absolute left-3 top-3 rounded-full bg-primary-500/90 px-3 py-1 text-xs font-semibold text-background-50 backdrop-blur-sm">
                {t.kicker}
              </span>
            </div>
            <div className="flex flex-1 flex-col p-5">
              <div className="flex items-center gap-2 text-xs text-accent-700">
                <i className="ri-folder-line" aria-hidden="true"></i>
                {t.count}
              </div>
              <h3 className="mt-2 font-heading text-lg font-bold text-foreground-950 group-hover:text-primary-700">
                {t.name}
              </h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-500">{t.desc}</p>
              <a
                href="#contact"
                onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                className="mt-4 inline-flex items-center gap-1.5 self-start whitespace-nowrap text-sm font-semibold text-primary-600 transition hover:text-primary-800"
              >
                查看专题内容 <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </a>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}